// Meta tag + Open Graph + robots

export const DEFAULT_SITE = 'https://kitapcik.net';
export const SITE_NAME = 'Türk Forum İstatistikleri';

function upsertMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel: string, href: string) {
  let el = document.querySelector(`link[rel="${rel}"]`) as HTMLLinkElement | null;
  if (!el) {
    el = document.createElement('link');
    el.rel = rel;
    document.head.appendChild(el);
  }
  el.href = href;
}

export type PageMetaOptions = {
  title: string;
  description: string;
  keywords: string;
  ogImage?: string;
  canonical?: string;
  ogType?: string;
  /** true: admin, embed, login, form sayfaları */
  noindex?: boolean;
  /** true: title olduğu gibi kullanılır (forum marka sayfaları) */
  titleExact?: boolean;
  /** og:site_name override (forum marka sayfaları) */
  siteName?: string;
};

export const setMetaTags = ({
  title,
  description,
  keywords,
  ogImage,
  canonical,
  ogType = 'website',
  noindex = false,
  titleExact = false,
  siteName,
}: PageMetaOptions) => {
  const fullTitle = titleExact
    ? title
    : title.includes(SITE_NAME)
      ? title
      : `${title} | ${SITE_NAME}`;
  document.title = fullTitle;

  upsertMeta('name', 'description', description);
  upsertMeta('name', 'keywords', keywords);
  upsertMeta('name', 'robots', noindex ? 'noindex, nofollow' : 'index, follow');

  upsertMeta('property', 'og:site_name', siteName || SITE_NAME);
  upsertMeta('property', 'og:locale', 'tr_TR');
  upsertMeta('property', 'og:title', fullTitle);
  upsertMeta('property', 'og:description', description);
  upsertMeta('property', 'og:type', ogType);
  upsertMeta('property', 'og:url', canonical || window.location.href);
  upsertMeta('property', 'og:image', ogImage || `${DEFAULT_SITE}/og-image.png`);

  upsertMeta('name', 'twitter:card', 'summary_large_image');
  upsertMeta('name', 'twitter:title', fullTitle);
  upsertMeta('name', 'twitter:description', description);
  upsertMeta('name', 'twitter:image', ogImage || `${DEFAULT_SITE}/twitter-card.png`);

  if (canonical) upsertLink('canonical', canonical);
};

export const resetMetaTags = () => {
  setMetaTags({
    title: "Türkiye'nin En Büyük Forum Siteleri Listesi",
    description:
      "Türkiye'nin en popüler forum sitelerinin güncel istatistikleri, üye sayıları, konu ve mesaj sayıları. Forum karşılaştırmaları ve detaylı analizler.",
    keywords:
      'türk forumları, forum istatistikleri, forum siteleri, forum karşılaştırma, türkiye forum listesi',
    canonical: DEFAULT_SITE,
  });
};

export function injectJsonLd(data: Record<string, unknown>, id = 'json-ld-page') {
  let script = document.getElementById(id) as HTMLScriptElement | null;
  if (!script) {
    script = document.createElement('script');
    script.id = id;
    script.type = 'application/ld+json';
    document.head.appendChild(script);
  }
  script.textContent = JSON.stringify(data);
}

export function removeJsonLd(id = 'json-ld-page') {
  document.getElementById(id)?.remove();
}

export function removeAllJsonLd() {
  document.querySelectorAll('script[type="application/ld+json"]').forEach((el) => {
    const id = el.id;
    if (id?.startsWith('json-ld-') || id === 'breadcrumb' || id === 'page') el.remove();
  });
}
